import { Box, Button, Card, CardContent, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import adminAPi from "../../../utils/adminAPi";
import FeTextField from "../../FormElements/FeTextField";
import { FeAutocomplete } from "../../FormElements";

const DiagDiseasesSubGroupForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [formValue, setFormValue] = useState({
    name: "",
    diagnosis_disease_group_record_id: null,
  });
  const [groupList, setGroupList] = useState([]);

  const [groupValue, setGroupValue] = useState(null);

  useEffect(() => {
    getGroupList();

    return () => {};
  }, []);

  const getGroupList = async () => {
    const { data } = await adminAPi.get(
      "admin/diagnosis-disease-group-records-all"
    );
    setGroupList(data.data);
  };
  useEffect(() => {
    if (id) {
      getDetails(id);
    }
  }, []);

  async function getDetails(id) {
    const { data } = await adminAPi.get(
      `admin/diagnosis-disease-subgroup-records/${id}`
    );
    setFormValue(data.data);
  }

  const handleField = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setFormValue({ ...formValue, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (id) {
        const { data } = await adminAPi.put(
          `admin/diagnosis-disease-subgroup-records/${id}`,
          formValue
        );
        navigate(pathname.substring(0, pathname.lastIndexOf("/")));
      } else {
        const { data } = await adminAPi.post(
          "admin/diagnosis-disease-subgroup-records",
          formValue
        );
        navigate(pathname.substring(0, pathname.lastIndexOf("/")));
      }
    } catch (error) {
      console.log(error.response);
    }
  };

  return (
    <Card sx={{ mt: 2 }}>
      <CardContent>
        <Grid container spacing={1}>
          <Grid item xs={6} md={6}>
            <Box mb={2}>
              <FeAutocomplete
                getOptionLabel={(option) => (id ? option.detail : option.name)}
                value={groupValue}
                onChange={(e, v) => {
                  if (!v) {
                    setGroupValue(v);
                    return;
                  }
                  setFormValue({
                    ...formValue,
                    diagnosis_disease_group_record_id: v.id,
                  });

                  setGroupValue(v);
                }}
                label={"Diagnosis Disease Group"}
                options={groupList}
                id="Histopathology"
              />
            </Box>
          </Grid>
          <Grid item sm={6}>
            <FeTextField
              name="name"
              id="name"
              label="Name"
              value={formValue.name}
              onChange={handleField}
            />
          </Grid>
        </Grid>
        <Box display="flex" justifyContent="flex-end" mt={2}>
          <Button type="submit" variant="contained" onClick={handleSubmit}>
            Submit
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};
export default DiagDiseasesSubGroupForm;
